import { Component, OnInit } from '@angular/core';
import { Router, RouterEvent, Event, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';
import { BaseComponent } from '../base/base.component';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/services/guard/auth.service';
import { DeviceDetectorService } from 'ngx-device-detector';
@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent extends BaseComponent {
  currentRoute = 'description';

  constructor(
    private router: Router,
    public translate: TranslateService,
    public authService: AuthService,
    deviceDetectorService: DeviceDetectorService,
    route: ActivatedRoute
  ) {
    super(translate, authService, deviceDetectorService, route);
    router.events.pipe(
      filter((e: Event): e is RouterEvent => e instanceof NavigationEnd)
    ).subscribe((e: NavigationEnd) => {
      const url = e.urlAfterRedirects.substr(1, e.urlAfterRedirects.length - 1);
      this.currentRoute = url;
    });

  }

  expand(expand) {
    if (this.isDesktop) {
      return;
    }

    const menu = $('.menu-container');
    if (this.isTablet) {
      if (expand) {
        menu.css('transform', 'translateX(0%)');
      } else {
        menu.css('transform', 'translateX(-100%)');
      }
    } else {
      if (expand) {
        menu.css('transform', 'translateY(0%)');
      } else {
        menu.css('transform', 'translateY(-100%)');
      }
    }
  }

  routeActive(route: string): boolean {
    return this.currentRoute.startsWith(route);
  }

  openMedia(media: string) {
    switch (media) {
      case 'fb':
        window.open('https://www.facebook.com/Villa-Skalaki-268584207403734/', '_blank');
        break;
      case 'insta':
        window.open('https://www.instagram.com/villaskalakicrete/?hl=fr', '_blank');
        break;
      case 'yt':
        window.open('https://www.youtube.com/channel/UCz8wdr-Kuru8LoRF9MkpESA', '_blank');
        break;
    }
  }

  changeLanguage(lg: string) {
    this.setLanguage(lg);
  }

  navigateHome() {
    this.router.navigate(['/home']);
  }

}
